import Circle from '../../atoms/icons/progressCircle';
import Container from '../../atoms/container/progressCircleContainer';
import { useEffect, useState } from 'react';

const OPACITY_TIMEOUT = 100;

function ProgressCircle({
  color,
  margin = true,
  percentage,
  text,
}: {
  color?: string;
  margin?: boolean;
  percentage?: number;
  text: string;
}) {
  const [opacity, setOpacity] = useState(0);

  useEffect(() => {
    setTimeout(() => {
      setOpacity(1);
    }, OPACITY_TIMEOUT);
  }, []);

  return (
    <Container
      id={'progressCircle'}
      className={'opacity-transition'}
      margin={margin}
      opacity={opacity}
    >
      <Circle
        percentage={percentage}
        strokeColor={color}
        text={text.toUpperCase()}
        textColor={'#FFFF'}
      />
    </Container>
  );
}

export default ProgressCircle;
